import React from "react"
import styled from "styled-components"
import { Link } from "gatsby"

export const PaginationWrapper = styled.section`
  grid-column: 2 / span 12;
  padding: 4.8rem 0;
  display: flex;
  align-items: center;
  justify-content: center;

  a:nth-child(1) {
    /* color: ${props =>
      props.isFirst ? props.theme.colors.base : props.theme.colors.base}; */
    pointer-events: ${props => (props.isFirst ? "none" : "auto")};
    cursor: ${props => (props.isFirst ? "default" : "pointer")};
  }

  a:nth-child(2) {
    /* color: ${props =>
      props.isLast ? props.theme.colors.base : props.theme.colors.base}; */
    pointer-events: ${props => (props.isLast ? "none" : "auto")};
    cursor: ${props => (props.isLast ? "default" : "pointer")};
  }

  @media ${props => props.theme.breakpoints.tablet} {
    grid-column: 2 / span 6;
  }
`

export const PaginationElement = styled(props => <Link {...props} />)`
  font-size: 1.4rem;
  line-height: 1.8rem;
  font-weight: 400;
  text-decoration: none;
  margin: 0 3.2rem;

  &:hover,
  &:focus {
    text-decoration: underline;
  }
`
